import { productionEnvironment } from './prod.env';
import { developmentEnvironment } from './dev.env';
import { preProductionEnvironment } from './pre-prod.env';
import { IEnvironment } from './types';

export const REACT_APP_ENV = import.meta.env.VITE_APP_ENV;

export let environment = (
  REACT_APP_ENV === 'main'
    ? productionEnvironment
    : REACT_APP_ENV?.includes('release')
      ? preProductionEnvironment
      : developmentEnvironment
) as IEnvironment;

// export const fetchAndApplyRemoteConfigToAppConfig = async (remoteConfigInstance: RemoteConfig) => {
//   try {
//     let appUrlConfig;
//     if (isPlatform('hybrid') ?? isPlatform('mobileweb')) {
//       const { value } = await FirebaseRemoteConfig.getString({
//         key: 'url_config',
//       });
//       appUrlConfig = value;
//     } else {
//       appUrlConfig = getString(remoteConfigInstance, 'url_config');
//     }
//
//     import.meta.env.DEV && console.log('appUrlConfig', appUrlConfig);
//     const appUrlConfigJSON = JSON.parse(appUrlConfig);
//     if (appUrlConfigJSON) {
//       environment = {
//         ...environment,
//         ...appUrlConfigJSON,
//       };
//     }
//   } catch (error) {
//     console.error('Error initializing app config:', error);
//   }
// };
